<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title
      :title="{ name: '所有申请', path: '/apply/allApply' }"
      :button-array="buttonArray"
      @exportApply="exportApply"
    ></Title>
    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="6">
            <el-input
              v-model="qparam.applyUserName"
              placeholder="申请人姓名"
            ></el-input>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="qparam.applyType"
              placeholder="申请类型"
              style="width: 100%"
            >
              <el-option
                v-for="item in flowData"
                :key="item.flowId"
                :label="item.flowName"
                :value="item.flowId"
              >
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="12">
            <el-date-picker
              v-model="applyTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerDateOpts"
            ></el-date-picker>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 10px; margin-left: 10px">
          <el-col :span="6" style="float: right">
            <el-button
              icon="el-icon-refresh-left"
              type="primary"
              @click="resetQparam"
              >重置</el-button
            >
            <el-button icon="el-icon-search" type="primary" @click="search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="申请类型">
            <template slot-scope="scope">
              <div v-for="(row, index) in flowData" :key="index">
                <el-tag type="success" v-if="row.flowId === scope.row.flowId">{{
                  row.flowName
                }}</el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="userName" label="申请人"> </el-table-column>

          <el-table-column prop="applyTime" label="申请时间"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="handleDetail(scope.$index, scope.row)"
                >查看申请
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 详情弹框 -->
        <el-dialog
            custom-class="no-padding-dialog no-margin-dialog"
            :title="detailDialogTitle"
            :visible.sync="showDetailDialog"
            width="100%"
            :before-close="handleDialogClose">
          <!-- 详情组件 -->
          <component :is="currentDetailComponent" :query="selectedQuery" />
        </el-dialog>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { requestAllApply, requestExportAllApply } from "@/api";
import Title from "../../Title";
import EnforceDetail from "../../item/enforce/EnforceDetail";
import ProjectDialog from "@/components/item/common/ProjectDialog.vue";
import {uuid} from "@/util";
import OutReportDetail from "@/components/item/outreport/OutReportDetail.vue";
import ProjectDetail from "@/components/item/project/ProjectDetail.vue";
import SealDetail from "@/components/item/seal/SealDetail.vue";
import CostReportDetail from "@/components/item/costreport/CostReportDetail.vue";
import PaymentDetail from "@/components/item/payment/PaymentDetail.vue";
import LeaveDetail from "@/components/item/leave/LeaveDetail.vue";
import ReimburseDetail from "@/components/item/reimburse/ReimburseDetail.vue";
import ContractDetail from "@/components/item/contract/ContractDetail.vue";
import CoworkingDetail from "@/components/item/coworking/CoworkingDetail.vue";
import ProjectModifyDetail from "@/components/item/project/ProjectModifyDetail.vue";
import PurchaseDetail from "@/components/item/purchase/PurchaseDetail.vue";
import AllegeDetail from "@/components/item/allege/AllegeDetail.vue";
import InvoiceDetail from "@/components/item/invoice/InvoiceDetail.vue";
import DeliveryDetail from "@/components/item/delivery/DeliveryDetail.vue";
import PettyCashDetail from "@/components/item/pettyCash/PettyCashDetail.vue";

export default {
  name: "AllApply",
  components: {ProjectDialog, Title,
    ProjectDetail, CostReportDetail, OutReportDetail, LeaveDetail,
    PaymentDetail, ReimburseDetail, SealDetail,
    EnforceDetail, ContractDetail, CoworkingDetail, ProjectModifyDetail,
    PurchaseDetail, AllegeDetail, InvoiceDetail, DeliveryDetail,PettyCashDetail
  },
  data() {
    return {
      uuid: "",
      tableData: [],
      totalElements: 0,
      qparam: {
        current: 1,
        size: 10,
        examineResult: "",
        applyType: "",
        applyUserName: "",
        auditUserName: "",
      },
      apply: {},
      applyTime: [],
      detailShow: false,
      projectId: "",

      buttonArray: [
        {
          type: "primary",
          title: "导出数据",
          method: "exportApply",
          disabled: false,
        },
      ],
      pickerDateOpts: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      showDetailDialog: false, // 控制弹框显示
      selectedQuery: {},       // 存储当前选中行的参数
      dataList: [],            // 列表数据
      applyType: "",           // 申请类型
      detailDialogTitle: ""    // dialog标题
    };
  },
  computed: {
    ...mapState(["flowData"]),
    // 动态选择详情组件
    currentDetailComponent() {
      switch (this.applyType) {
        case 1:
          this.detailDialogTitle = "立项申请详情";
          return "ProjectDetail";
        case 2:
          this.detailDialogTitle = "招待费申请详情";
          return "CostReportDetail";
        case 3:
          this.detailDialogTitle = "外出申请详情";
          return "OutReportDetail";
        case 4:
          this.detailDialogTitle = "请假申请详情";
          return "LeaveDetail";
        case 5:
          this.detailDialogTitle = "付款申请详情";
          return "PaymentDetail";
        case 6:
          this.detailDialogTitle = "费用报销申请详情";
          return "ReimburseDetail";
        case 7:
          this.detailDialogTitle = "用章申请详情";
          return "SealDetail";
        case 9:
          this.detailDialogTitle = "实施文件归档详情"
          return "EnforceDetail";
        case 10:
          this.detailDialogTitle = "合同文件归档详情";
          return "ContractDetail";
        case 11:
          this.detailDialogTitle = "协同办公申请详情";
          return "CoworkingDetail";
        case 12:
          this.detailDialogTitle = "项目变更申请详情";
          return "ProjectModifyDetail";
        case 13:
          this.detailDialogTitle = "采购申请详情";
          return "PurchaseDetail";
        case 14:
          this.detailDialogTitle = "考勤申诉详情";
          return "AllegeDetail";
        case 15:
          this.detailDialogTitle = "发票开具申请详情";
          return "InvoiceDetail";
        case 16:
          this.detailDialogTitle = "项目交付申请详情";
          return "DeliveryDetail";
        case 17:
          this.detailDialogTitle = "备用金申请详情"
          return "PettyCashDetail"
        default:
          this.detailDialogTitle = "";
          return "";
      }
    },
  },
  methods: {
    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData();
    },
    resetQparam() {
      this.qparam.applyType = "";
      this.applyTime = [];
      this.qparam.applyUserName = "";
      this.qparam.auditUserName = "";
      this.initTableData();
    },
    handleDetail(index, row) {
      this.selectedQuery = {
        applyId: row.applyId,
        applyServiceId: row.applyServiceId,
        applyType: row.applyType,
      }
      this.applyType = row.applyType;
      this.showDetailDialog = true;
      this.uuid = uuid();
      // this.$router.push({
      //   path: row.path,
      //   query: {
      //     applyId: row.applyId,
      //     applyServiceId: row.applyServiceId,
      //     applyType: row.applyType,
      //   },
      // });
    },
    handleDialogClose() {
      // 关闭弹框前可以进行一些清理操作
      this.selectedQuery = {};
      this.applyType = "";
      this.showDetailDialog = false;
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData();
    },
    async search() {
      this.qparam.current = 1;
      await this.initTableData();
    },
    async initTableData() {
      this.qparam.startTime = this.applyTime[0];
      this.qparam.endTime = this.applyTime[1];
      const res = await requestAllApply(this.qparam);
      if (res.code == 200) {
        this.totalElements = res.total;
        this.tableData = res.rows;
      } else {
        this.$message.error(res.msg);
      }
    },
    exportApply() {
      requestExportAllApply(this.qparam).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          window.location.href = res.object;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  created() {
    this.initTableData();
  },
};
</script>

<style scoped>
::v-deep .no-padding-dialog .el-dialog__body {
  padding: 0;
  margin-top: 0 !important;
}
::v-deep .no-margin-dialog {
  margin-top: 0 !important;
}
</style>
